"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.dynamicListings.name': 'Listados Dinámicos',
    'tools.dynamicListings.description': 'Muestra un panel de listados contextual cuando se cumple una condición específica de la conversación',
};
